import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAddAdHocItem } from './useAddAdHocItem'
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus'

export function AddAdHocItemForm() {
  const { t } = useTranslation('grocery-list')
  const { mutate, isPending } = useAddAdHocItem()
  const { isOnline } = useNetworkStatus()
  const [name, setName] = useState('')

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const trimmed = name.trim()
    if (!trimmed) return

    mutate({ name: trimmed })
    setName('')
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault()
      const trimmed = name.trim()
      if (!trimmed) return

      mutate({ name: trimmed })
      setName('')
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center gap-2 px-4 py-3 print:hidden"
    >
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('addItem.placeholder')}
        disabled={!isOnline || isPending}
        className="flex-1 rounded-md border border-line bg-canvas px-3 py-2 text-sm text-ink placeholder:text-muted disabled:opacity-50"
      />
      <button
        type="submit"
        disabled={!isOnline || isPending || !name.trim()}
        aria-label={t('addItem.submitAriaLabel')}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
      >
        {t('addItem.submit')}
      </button>
    </form>
  )
}
